import config from '../../config/config';

import getRequest from './base/get';
import postRequest from './base/post';

export default {
  /**
   * Fetch platform level data
   * @returns
   */
  fetchPlatformLevel: (): Promise<any> => {
    return getRequest(`${config.accountApiUrl}api/super-admin/v1/settings`);
  },
  /**
   * Fetch platform level data
   * @returns
   */
  createAccountLevel: (data: any): Promise<any> => {
    const parameters = { ...data };
    return postRequest(
      `${config.accountApiUrl}api/super-admin/v1/facility-account/settings`,
      parameters,
    );
  },
  /**
   * Update platform level data
   * @param data
   * @returns
   */
  updatePlatformLevel: (data: any): Promise<any> => {
    const parameters = { ...data };
    return postRequest(`${config.accountApiUrl}api/super-admin/v1/settings`, parameters);
  },
};
